import Breadcrumbs from "@/components/Breadcrumb";
import { PageSuspense } from "@/components/PageSuspense";
import { useEscapeShortcut } from "@/hooks/use-escape-shortcut";
import type { FC } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export const SettingsPageLayout: FC = () => {
    const navigate = useNavigate();
    useEscapeShortcut(() => {
        navigate("/");
    });

    return (
        <div className="flex flex-col gap-2" data-testid="settings-page-layout">
            <div>
                <Breadcrumbs />
            </div>
            <div>
                <PageSuspense>
                    <Outlet />
                </PageSuspense>
            </div>
        </div>
    );
};
